import React from 'react';
import { Star } from 'lucide-react';
const comments = [{
  quote: 'Ahora entro a la guardia con otra seguridad.',
  name: 'Sofía V.',
  role: 'Enfermera'
}, {
  quote: 'Antes dudaba, ahora tengo un sistema.',
  name: 'Daniela P.',
  role: 'Estudiante'
}, {
  quote: 'Me cambió completamente la forma de trabajar.',
  name: 'Gabriel S.',
  role: 'Enfermero'
}];
export function TestimonialsPreGuarantee() {
  return <section className="bg-brand-dark py-5 px-5" data-id="element-311">
      <div className="max-w-xl mx-auto" data-id="element-312">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-2" data-id="element-313">
          🏥 Profesionales reales, resultados reales
        </h2>
        <p className="text-sm text-gray-500 text-center mb-8" data-id="element-314">
          Esto dicen quienes ya aplican el sistema en su trabajo
        </p>

        <div className="space-y-3" data-id="element-315">
          {comments.map((c, i) => <div key={i} className="bg-white/5 backdrop-blur-sm border border-white/10 p-4 rounded-xl transition-all hover:bg-white/10" data-id="element-316">
              <div className="flex gap-0.5 mb-2" data-id="element-317">
                {[...Array(5)].map((_, j) => <Star key={j} size={12} className="fill-brand-yellow text-brand-yellow" data-id="element-318" />)}
              </div>
              <p className="text-gray-300 italic text-sm mb-2 leading-relaxed" data-id="element-319">
                "{c.quote}"
              </p>
              <div className="flex items-center gap-2" data-id="element-320">
                <div className="w-7 h-7 rounded-full bg-gray-700 flex items-center justify-center text-xs font-bold text-brand-yellow flex-shrink-0" data-id="element-321">
                  {c.name.charAt(0)}
                </div>
                <div data-id="element-322">
                  <p className="font-bold text-white text-xs" data-id="element-323">{c.name}</p>
                  <p className="text-[11px] text-gray-500" data-id="element-324">{c.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}